import { render, staticRenderFns } from "./LeaveTypeSettingsForm.vue?vue&type=template&id=82841500&"
import script from "./LeaveTypeSettingsForm.vue?vue&type=script&lang=js&"
export * from "./LeaveTypeSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports